import { FC, lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import TopBarProgress from "react-topbar-progress-indicator";
import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
import ManagementHome from "../modules/customs/management/managementHome/ManagementHome";
import AddUser from "../modules/customs/management/managementUsers/addUser/AddUser";
import EditUser from "../modules/customs/management/managementUsers/editUser/EditUser";
import { usePermitted } from "../modules/customs/lib/checkPermission/CheckPermission";
import WomenFanCardList from "../modules/customs/womenFanCard/womenFanCardList";
import WomenFanCardDetails from "../modules/customs/womenFanCard/WomenFanCardDetails";
import AddTicketInPerson from "../modules/customs/ticketInPerson/AddTicketInPerson";
import MatchTiketPersonList from "../modules/customs/ticketInPerson/MatchTiketPersonList";
import AddTicketSpecial from "../modules/customs/specialTicket/AddTicketSpecial";
import TicketInSpecialList from "../modules/customs/specialTicket/TicketInSpecialList";
import ProvinceReport from "../modules/customs/reports/ProvinceReport";
import TicketInPersonList from "../modules/customs/ticketInPerson/TicketInPersonList";
import MatchTicketSpecialList from "../modules/customs/specialTicket/MatchTicketSpecialList";
import FanReport from "../modules/customs/reports/FanReport";
import FanLogReport from "../modules/customs/reports/FanLogReport";
import ProvinceReportList from "../modules/customs/reports/ProvinceReportList";
import FanReportListMatch from "../modules/customs/reports/fanReportMatch/FanReportListMatch";
import FanReportLogList from "../modules/customs/reports/fanReportMatch/fanReportLogList";
import FanReportListUsers from "../modules/customs/reports/fanReportUsers/FanReportListUsers";
import FansReportList from "../modules/customs/reports/FansReport/FansReportList";
import FanReportLogListUsers from "../modules/customs/reports/fanReportUsers/FanReportLogListUsers";
import FansReportLogList from "../modules/customs/reports/FansReport/FansReportLogList";
import FanReportSpecialPerMatch from "../modules/customs/reportSpecial/fanReportPerMatch/FanReportSpecialPerMatch";
import SaleRportSpecial from "../modules/customs/reportSpecial/fanReportPerMatch/saleRportSpecial";
import AddExcelTicketSpecial from "../modules/customs/specialTicket/AddExcelTicketSpecial";
import FanReportSpecialCensusList from "../modules/customs/reportSpecial/fanreportSpecialCensus/FanReportSpecialCensusList";
import ProvinceReportSpecialList from "../modules/customs/reportSpecial/provinceReportSpecial/ProvinceReportSpecialList";
import ReportWomenFanCardList from "../modules/customs/reportSpecial/RportWomen/ReportWomenFanCardList";
import ReportAttendeLogPage from "../modules/customs/reportSpecial/reporSpecialLog/ReportAttendeLogPage";
import CreateFanCard from "../modules/customs/womenFanCard/CreateFanCard";
import LotteryPage from "../modules/customs/lottery/LotteryPage";
import LotteryLis from "../modules/customs/lottery/LotteryLis";
import LotteryDetails from "../modules/customs/lottery/LotteryDetails";
const PrivateRoutes = () => {
  const FileManager = lazy(
    () => import("../modules/customs/fileManager/FileManager")
  );

  const Tables = lazy(() => import("../modules/customs/tables/tables"));
  const Profile = lazy(() => import("../modules/customs/profile/profile"));

  //operator
  const ManagementUsers = lazy(
    () =>
      import("../modules/customs/management/managementUsers/ManagementUsers")
  );

  const UserDetailes = lazy(
    () =>
      import(
        "../modules/customs/management/managementUsers/userDetailes/UserDetailes"
      )
  );

  const CreateRole = lazy(
    () =>
      import("../modules/customs/management/managementRoles/addRole/AddRole")
  );

  const EditRole = lazy(
    () =>
      import("../modules/customs/management/managementRoles/addRole/EditRole")
  );

  const ManagementRoles = lazy(
    () =>
      import("../modules/customs/management/managementRoles/ManagementRoles")
  );
  const ManagementAccesses = lazy(
    () =>
      import(
        "../modules/customs/management/managementAccesses/ManagementAccesses"
      )
  );
  const ManagementAccessesSpecial = lazy(
    () =>
      import(
        "../modules/customs/management/managementAccessesSpecial/ManagementAccessesSpecial"
      )
  );
  const ManagementAccessesSpecialList = lazy(
    () =>
      import(
        "../modules/customs/management/managementAccessesSpecial/ManagementAccessesSpecialList"
      )
  );

  const ManagementPermissionEdit = lazy(
    () =>
      import(
        "../modules/customs/management/managementAccesses/addPermission/EditPermission"
      )
  );

  const ManagementPermissionCreate = lazy(
    () =>
      import(
        "../modules/customs/management/managementAccesses/addPermission/AddPermission"
      )
  );

  const isMenuManagementPermitted = usePermitted("menu-management");

  // gate
  const GateList = lazy(() => import("../modules/customs/gates/GateList"));
  const EditGate = lazy(() => import("../modules/customs/gates/EditGate"));
  const AddGate = lazy(() => import("../modules/customs/gates/AddGate"));
  // teams
  const TeamsList = lazy(() => import("../modules/customs/teams/TeamsList"));
  const EditTeam = lazy(() => import("../modules/customs/teams/EditTeam"));
  // leagues
  const LeaguesList = lazy(
    () => import("../modules/customs/leagues/LeaguesList")
  );
  const EditLeague = lazy(
    () => import("../modules/customs/leagues/EditLeague")
  );
  // matches
  const MatchesList = lazy(
    () => import("../modules/customs/matches/MatchesList")
  );
  const EditMatch = lazy(() => import("../modules/customs/matches/EditMatch"));

  // reports
  const SaleReportList = lazy(
    () => import("../modules/customs/reports/SaleReportList")
  );

  const WomenFanCardReports = lazy(
    () => import("../modules/customs/womenFanCard/WomenFanCardReports")
  );

  const CityReportlist = lazy(
    () => import("../modules/customs/reports/CityReportlist")
  );

  const UserInfo = lazy(() => import("../modules/customs/reports/UserInfo"));
  const UserReport = lazy(
    () => import("../modules/customs/reports/UserReport")
  );

  // stadium-profiles
  const ProfilesList = lazy(
    () => import("../modules/customs/stadiumProfiles/ProfilesList")
  );
  const AddProfilePlatform = lazy(
    () => import("../modules/customs/stadiumProfiles/AddProfilePlatform")
  );
  const EditProfile = lazy(
    () => import("../modules/customs/stadiumProfiles/EditProfile")
  );

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />
        {/* Pages */}
        <Route path="defDash" element={<DashboardWrapper />} />

        <Route
          path="dashboard"
          element={
            isMenuManagementPermitted ? (
              <ManagementHome />
            ) : (
              <div>خوش امدید</div>
            )
          }
        />
        <Route path={"file-manager/file/files"}>
          <Route
            index
            element={
              <SuspensedView>
                <FileManager />
              </SuspensedView>
            }
          />
          <Route
            path={":filePath"}
            element={
              <SuspensedView>
                <FileManager />
              </SuspensedView>
            }
          />
        </Route>

        {/* gate routes ----------------------------------------------------- */}
        <Route path={"gate"}>
          <Route
            path={"gate-list"}
            element={
              <SuspensedView>
                <GateList />
              </SuspensedView>
            }
          />
          <Route
            path={"add-gate"}
            element={
              <SuspensedView>
                <AddGate />
              </SuspensedView>
            }
          />
          <Route
            path={"edit-gate"}
            element={
              <SuspensedView>
                <EditGate />
              </SuspensedView>
            }
          />
        </Route>

        {/* teams routes ----------------------------------------------------- */}
        <Route path={"teams"}>
          <Route
            path={"teams-list"}
            element={
              <SuspensedView>
                <TeamsList />
              </SuspensedView>
            }
          />
          <Route
            path={"add-team"}
            element={
              <SuspensedView>
                <EditTeam />
              </SuspensedView>
            }
          />
          <Route
            path={"edit-team"}
            element={
              <SuspensedView>
                <EditTeam />
              </SuspensedView>
            }
          />
        </Route>
        {/* leagues routes ----------------------------------------------------- */}
        <Route path={"leagues"}>
          <Route
            path={"leagues-list"}
            element={
              <SuspensedView>
                <LeaguesList />
              </SuspensedView>
            }
          />
          <Route
            path={"add-league"}
            element={
              <SuspensedView>
                <EditLeague />
              </SuspensedView>
            }
          />
          <Route
            path={"edit-league"}
            element={
              <SuspensedView>
                <EditLeague />
              </SuspensedView>
            }
          />
        </Route>
        {/* matches routes ----------------------------------------------------- */}
        <Route path={"matches"}>
          <Route
            path={"matches-list"}
            element={
              <SuspensedView>
                <MatchesList />
              </SuspensedView>
            }
          />
          <Route
            path={"add-match"}
            element={
              <SuspensedView>
                <EditMatch />
              </SuspensedView>
            }
          />
          <Route
            path={"edit-match"}
            element={
              <SuspensedView>
                <EditMatch />
              </SuspensedView>
            }
          />
        </Route>

        {/* reports special routes ----------------------------------------------------- */}
        <Route path={"reports-special"}>
          <Route
            path={"fan-report-list-per-match"}
            element={
              <SuspensedView>
                <FanReportSpecialPerMatch />
              </SuspensedView>
            }
          />

          <Route
            path={"province-reportSpecial-List"}
            element={
              <SuspensedView>
                <ProvinceReportSpecialList />
              </SuspensedView>
            }
          />

          <Route
            path={"fan-report-attendes-all"}
            element={
              <SuspensedView>
                <FanReportSpecialCensusList />
              </SuspensedView>
            }
          />
          <Route
            path={"sale-report-special"}
            element={
              <SuspensedView>
                <SaleRportSpecial />
              </SuspensedView>
            }
          />
          <Route
            path={"repoetfans-log-list"}
            element={
              <SuspensedView>
                <ReportAttendeLogPage />
              </SuspensedView>
            }
          />
          <Route
            path={"reportspecial-women-fan-card"}
            element={
              <SuspensedView>
                <WomenFanCardReports />
              </SuspensedView>
            }
          />
          <Route
            path={"women-fan-cardList-detalis"}
            element={
              <SuspensedView>
                <ReportWomenFanCardList />
              </SuspensedView>
            }
          />
        </Route>
        {/* reports routes ----------------------------------------------------- */}
        <Route path={"reports"}>
          <Route
            path={"finished-matches"}
            element={
              <SuspensedView>
                <SaleReportList />
              </SuspensedView>
            }
          />
          <Route
            path={"women-fan-card"}
            element={
              <SuspensedView>
                <WomenFanCardReports />
              </SuspensedView>
            }
          />
          <Route
            path={"fan-report-list"}
            element={
              <SuspensedView>
                <FanReport />
              </SuspensedView>
            }
          />
          <Route
            path={"fan-report-list-match"}
            element={
              <SuspensedView>
                <FanReportListMatch />
              </SuspensedView>
            }
          />
          <Route
            path={"fan-report-log"}
            element={
              <SuspensedView>
                <FanReportLogList />
              </SuspensedView>
            }
          />
          <Route
            path={"fans-list"}
            element={
              <SuspensedView>
                <FansReportList />
              </SuspensedView>
            }
          />
          <Route
            path={"fans-log-all-match"}
            element={
              <SuspensedView>
                <FansReportLogList />
              </SuspensedView>
            }
          />
          <Route
            path={"fan-log-report"}
            element={
              <SuspensedView>
                <FanLogReport />
              </SuspensedView>
            }
          />
          <Route
            path={"fan-users-list"}
            element={
              <SuspensedView>
                <FanReportListUsers />
              </SuspensedView>
            }
          />
          <Route
            path={"fan-users-log"}
            element={
              <SuspensedView>
                <FanReportLogListUsers />
              </SuspensedView>
            }
          />
          <Route
            path={"province-report-list"}
            element={
              <SuspensedView>
                <ProvinceReportList />
              </SuspensedView>
            }
          />
          <Route
            path={"city-report-list"}
            element={
              <SuspensedView>
                <CityReportlist />
              </SuspensedView>
            }
          />
          <Route
            path={"user-info"}
            element={
              <SuspensedView>
                <UserInfo />
              </SuspensedView>
            }
          />
          <Route
            path={"user-report"}
            element={
              <SuspensedView>
                <UserReport />
              </SuspensedView>
            }
          />
          <Route
            path={"province-report"}
            element={
              <SuspensedView>
                <ProvinceReport />
              </SuspensedView>
            }
          />
        </Route>

        {/*  ticket in person ----------------------------------------------------- */}
        <Route path={"ticket-in-person"}>
          <Route
            path={"ticket"}
            element={
              <SuspensedView>
                <MatchTiketPersonList />
              </SuspensedView>
            }
          />
          <Route
            path={"ticket-person-details"}
            element={
              <SuspensedView>
                <TicketInPersonList />
              </SuspensedView>
            }
          />

          <Route
            path={"add-ticket"}
            element={
              <SuspensedView>
                <AddTicketInPerson />
              </SuspensedView>
            }
          />

          <Route
            path={"edit-profile"}
            element={
              <SuspensedView>
                <EditProfile />
              </SuspensedView>
            }
          />
        </Route>
        {/* ticket-in-special */}
        <Route path={"ticket-in-special"}>
          <Route
            path={"ticket"}
            element={
              <SuspensedView>
                <MatchTicketSpecialList />
              </SuspensedView>
            }
          />
          <Route
            path={"ticket-special-details"}
            element={
              <SuspensedView>
                <TicketInSpecialList />
              </SuspensedView>
            }
          />
          <Route
            path={"add-ticket-special"}
            element={
              <SuspensedView>
                <AddTicketSpecial />
              </SuspensedView>
            }
          />
          <Route
            path={"add-excel-special"}
            element={
              <SuspensedView>
                <AddExcelTicketSpecial />
              </SuspensedView>
            }
          />
        </Route>
        {/* stadium profiles routes ----------------------------------------------------- */}
        <Route path={"stadiumProfiles"}>
          <Route
            path={"profiles-list"}
            element={
              <SuspensedView>
                <ProfilesList />
              </SuspensedView>
            }
          />
          <Route
            path={"add-profile"}
            element={
              <SuspensedView>
                <AddProfilePlatform />
              </SuspensedView>
            }
          />
          <Route
            path={"edit-profile"}
            element={
              <SuspensedView>
                <EditProfile />
              </SuspensedView>
            }
          />
        </Route>
        {/*  operator routes ----------------------------------------------------- */}
        <Route path={"operator"}>
          <Route
            path={"users"}
            element={
              <SuspensedView>
                <ManagementUsers />
              </SuspensedView>
            }
          />
          <Route
            path={"users-create"}
            element={
              <SuspensedView>
                <AddUser />
              </SuspensedView>
            }
          />
          <Route
            path={"users-edit/:userId"}
            element={
              <SuspensedView>
                <EditUser />
              </SuspensedView>
            }
          />
          <Route
            path={"users-details/:id"}
            element={
              <SuspensedView>
                <UserDetailes id={undefined} />
              </SuspensedView>
            }
          />
          <Route
            path={"roles"}
            element={
              <SuspensedView>
                <ManagementRoles />
              </SuspensedView>
            }
          />
          <Route
            path={"roles-create"}
            element={
              <SuspensedView>
                <CreateRole />
              </SuspensedView>
            }
          />
          <Route
            path={"roles-create/:roleId"}
            element={
              <SuspensedView>
                <EditRole />
              </SuspensedView>
            }
          />
          <Route
            path={"accesses"}
            element={
              <SuspensedView>
                <ManagementAccesses />
              </SuspensedView>
            }
          />
          <Route
            path={"organization-list"}
            element={
              <SuspensedView>
                <ManagementAccessesSpecialList />
              </SuspensedView>
            }
          />
          <Route
            path={"add-organization"}
            element={
              <SuspensedView>
                <ManagementAccessesSpecial />
              </SuspensedView>
            }
          />
          <Route
            path={"create-permission"}
            element={
              <SuspensedView>
                <ManagementPermissionCreate />
              </SuspensedView>
            }
          />
          <Route
            path={"edit-permission"}
            element={
              <SuspensedView>
                <ManagementPermissionEdit />
              </SuspensedView>
            }
          />
        </Route>

        {/*  menu-management-fan ----------------------------------------------------- */}

        <Route path={"management-fan"}>
          <Route
            path={"list-fan"}
            element={
              <SuspensedView>
                <EditUser />
              </SuspensedView>
            }
          />
          {/* women fan card ----------------------------------------------------- */}
          <Route
            path={"list-women"}
            element={
              <SuspensedView>
                <WomenFanCardList />
              </SuspensedView>
            }
          />
          <Route
            path={"create-fan-card"}
            element={
              <SuspensedView>
                <CreateFanCard />
              </SuspensedView>
            }
          />
          <Route
            path={"add-lottery"}
            element={
              <SuspensedView>
                <LotteryPage />
              </SuspensedView>
            }
          />
          <Route
            path={"lottery-list"}
            element={
              <SuspensedView>
                <LotteryLis />
              </SuspensedView>
            }
          />
          <Route
            path={"lottery-details"}
            element={
              <SuspensedView>
                <LotteryDetails />
              </SuspensedView>
            }
          />
          <Route
            path={"details"}
            element={
              <SuspensedView>
                <WomenFanCardDetails />
              </SuspensedView>
            }
          />
        </Route>

        {/* pages routes ----------------------------------------------------- */}
        <Route path={"pages"}>
          {/* <Route
            path={"pages-list"}
            element={
              <SuspensedView>
                <div>pages list</div>
              </SuspensedView>
            }
          /> */}
          <Route
            path={"add-page"}
            element={
              <SuspensedView>
                <div>add page</div>
              </SuspensedView>
            }
          />
          <Route
            path={"edit-page"}
            element={
              <SuspensedView>
                <div>edit page</div>
              </SuspensedView>
            }
          />
          <Route
            path={"tables"}
            element={
              <SuspensedView>
                <Tables />
              </SuspensedView>
            }
          />
          <Route
            path={"profile"}
            element={
              <SuspensedView>
                <Profile />
              </SuspensedView>
            }
          />
        </Route>

        <Route
          path="user-logs/nationalCode/:nationalCode"
          element={<FansReportLogList />}
        />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue("--bs-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
